import { z } from 'zod'
import { CurrencyCodeSchema } from '@omnea-app/packages/universal/currency-utils/getCurrencyCodes'
import { AttributeTypesSchema } from '@omnea-app/packages/universal/documents/constants'

const PaymentInterval = {
  EVERY_SIX_MONTHS: 'EVERY_SIX_MONTHS',
  MONTH: 'MONTH',
  MULTI_YEAR: 'MULTI_YEAR',
  ONE_OFF: 'ONE_OFF',
  QUARTER: 'QUARTER',
  WEEK: 'WEEK',
  YEAR: 'YEAR',
}
const PaymentIntervalSchema = z.union([
  z.literal(PaymentInterval.EVERY_SIX_MONTHS),
  z.literal(PaymentInterval.MONTH),
  z.literal(PaymentInterval.MULTI_YEAR),
  z.literal(PaymentInterval.ONE_OFF),
  z.literal(PaymentInterval.QUARTER),
  z.literal(PaymentInterval.WEEK),
  z.literal(PaymentInterval.YEAR),
])

const PriceAttributeSchema = z.object({
  paymentInterval: PaymentIntervalSchema.optional(),
  currency: CurrencyCodeSchema,
  amount: z.string(),
})

export const ExtractedAttributeSchema = z.object({
  label: z.string(),
  value: z.union([z.string(), z.boolean(), z.number(), z.string().datetime(), PriceAttributeSchema]).optional(),
  type: AttributeTypesSchema,
})
export type ExtractedAttribute = z.infer<typeof ExtractedAttributeSchema>
